import { getLocale, request } from '@pb/utils'

import { News } from './duck/types'

const fetchNews = (): Promise<News[]> =>
  request
    .get(`${getLocale()}.newsWidget.json`, {
      use: { apiVersion: false, locale: false },
    })
    .then((res) => res.data)

export default {
  fetchNews,
}
